// extracted by mini-css-extract-plugin
module.exports = {"heading":"PostBookingSurveyConfirmation_heading__A_Agy","text":"PostBookingSurveyConfirmation_text__aJaWf","confirmButton":"PostBookingSurveyConfirmation_confirmButton__lYT6z"};